import { localStoragePageInfo } from './local-storage-service';
import jwtDecode from 'jwt-decode';

const isAuth = (id: string): boolean => !!localStoragePageInfo.getStorageProperty(id || '', 'jwtToken');

const clearPresenterStorage = (id: string): void => localStorage.removeItem(id);

const clearJwt = (id: string): void => localStoragePageInfo.removeStorageValue(id, 'jwtToken');

const setJwtToken = (id: string, value: string): void => localStoragePageInfo.setStorageProperty(id, 'jwtToken', value);

const getJwtToken = (id: string): string | null => localStoragePageInfo.getStorageProperty(id, 'jwtToken');

const decodeJwt = <T>(token: string): T | null => {
  if (!token) return null;
  try {
    return jwtDecode(token);
  } catch (e) {
    return null;
  }
};

export const authService = {
  isAuth,
  clearJwt,
  setJwtToken,
  getJwtToken,
  decodeJwt,
  clearPresenterStorage
};

